
import { Activity, ArrowRight, BarChart3, Clock3, Gauge, Inbox, Layers3, Users } from 'lucide-react'
import { Link } from 'react-router-dom'

const features = [
  [Inbox, 'Live queue visibility', 'See what is waiting now, how long it has been waiting and which customer emails have crossed your organisation’s response thresholds.'],
  [Clock3, 'Response cycle time', 'Measure customer email arrival to reply sent so managers can see actual response performance against SLA targets.'],
  [Gauge, 'SLA Performance', 'Set and monitor service-level response targets by organisation, team, work category and complexity without changing the measured timing.'],
  [Users, 'Team accountability', 'See measured workload, replies and open work across the people responsible for customer email.'],
  [BarChart3, 'Operating summaries', 'Bring demand, backlog, response output, staffing context and SLA attainment into a single daily view.'],
  [Layers3, 'Category and complexity context', 'Classify work by category and complexity so different kinds of customer conversations can be measured against appropriate standards.'],
] as const

export function Product() { return <>
  <section className="public-page-hero public-container">
    <span className="public-kicker">Product</span>
    <h1>Understand the full path from customer email to response.</h1>
    <p>
      Mail Percent measures when customer email is received, when a reply is sent, current queue pressure and workload, then compares those signals with your SLA targets.
    </p>
    <div className="public-hero-actions">
      <Link to="/signup" className="button primary public-cta">Get started <ArrowRight size={16}/></Link>
      <Link to="/how-it-works" className="button ghost public-cta">How it works</Link>
    </div>
  </section>

  <section className="public-section public-container">
    <div className="public-feature-grid three">
      {features.map(([Icon,title,text]) =>
        <article className="public-feature-card" key={title}>
          <div className="feature-icon"><Icon/></div>
          <h3>{title}</h3>
          <p>{text}</p>
        </article>
      )}
    </div>
  </section>

  <section className="public-section public-soft-section">
    <div className="public-container public-split-section light">
      <div>
        <span className="public-kicker">Better accountability needs better context</span>
        <h2>Know whether the gap is follow-through, workload or both.</h2>
        <p>
          A slow customer response can come from a neglected email, a heavy queue or a genuinely complex case. Mail Percent gives your managers the evidence to see the difference and act on the right problem.
        </p>
        <ul className="public-check-list">
          <li><Activity/>Arrival → reply sent</li>
          <li><Activity/>First-response SLA result</li>
          <li><Activity/>Unreplied customer emails</li>
          <li><Activity/>Queue pressure and response cycle</li>
        </ul>
      </div>

      <div className="public-data-card">
        <small>Customer email operating record</small>
        <div><span>Arrival</span><strong>09:14</strong></div>
        <div><span>First reply sent</span><strong>09:31</strong></div>
        <div><span>Response time</span><strong>17m</strong></div>
        <div><span>Queue state</span><strong>Replied</strong></div>
        <footer><span>SLA Performance</span><b>Within SLA</b></footer>
      </div>
    </div>
  </section>
</> }
